<template>
  <el-container>
    <el-aside width="300px"></el-aside>
    <el-main>
      <el-card class="box">
      <template v-slot:header>
        <div class="card-header">
            <span style="font-weight: bold;color: #F1F7E7;font-size: 20px;">
              <i class="el-icon-tickets" style="font-weight: bold;font-size: 20px;margin-right: 5px;"></i>Overlap Analysis of Enhancers</span>
        </div>
      </template>
      <div>
        <el-col :span="12">
          <el-row>
            <el-form>
              <el-form-item label="bed 1" style="font-weight: bold;">
                <el-input v-model="bedFileName1" placeholder="Please select bed file" readonly></el-input>
                <el-upload
                  class="upload-btn"
                  action="http://183.175.59.4/devenhancer/overlap/"
                  :show-file-list="false"
                  :on-success="handleUploadSuccess"
                  :before-upload="beforeUpload1"
                >
                  <el-button size="medium" slot:trigger type="primary" style="background-color: #2C3E50;border: 1px solid #2C3E50;margin-top: 10px;">select file</el-button>
                </el-upload>
              </el-form-item>
              <el-form-item label="bed 2" style="font-weight: bold;">
                <el-input v-model="bedFileName2" placeholder="Please select bed file" readonly></el-input>
                <el-upload
                  class="upload-btn"
                  action="http://183.175.59.4/devenhancer/overlap/"
                  :show-file-list="false"
                  :on-success="handleUploadSuccess"
                  :before-upload="beforeUpload2"
                >
                  <el-button size="medium" slot:trigger type="primary" style="background-color: #2C3E50;border: 1px solid #2C3E50;margin-top: 10px;">select file</el-button>
                </el-upload>
              </el-form-item>
              <el-form-item>
                <el-button size="medium" type="primary" @click="submitForm" :loading="loading" style="background-color: #2C3E50;border: 1px solid #2C3E50;">analysis</el-button>
              </el-form-item>
              <el-form-item>
                  <a href="@/../static/download/ESC_SE.bed" download="">
                    <el-button size="medium" type="primary" style="background-color: #2C3E50;border: 1px solid #2C3E50;">example1</el-button>
                  </a>
                  <a href="@/../static/download/PreME_SE.bed" download="">
                    <el-button size="medium" type="primary" style="background-color: #2C3E50;border: 1px solid #2C3E50;">example2</el-button>
                  </a>
                </el-form-item>
            </el-form>
          </el-row>
        </el-col>
        <el-col :span="12" class="col2">
          <h3 style="color:red">Function:</h3>
          <p style="font-size: large;">This analysis identifies whether two bed files have common <span style="color:red">enhancers</span>, 
          as well as recreated <span style="color:red">enhancers</span>.</p>
          <h3 style="color:red">Usage:</h3>
          <p style="font-size:  large;">First, click to upload two <span style="color:red">bed</span> files and then click Analyze. We suggest bed 1 for early and bed 2 for late.
            You can click on "example1" and "example2" to show example files.</p>
        </el-col>
      </div>
    </el-card>
    </el-main>
    <el-aside width="300px"></el-aside>
  </el-container>
</template>

<script>
export default {
  data() {
    return {
      bedData1: null,
      bedFileName1: '',
      bedData2: null,
      bedFileName2: '',
      dlProgress: 0,
      loading: false, // 添加 loading 状态
    };
  },
  methods: {
    beforeUpload1(file) {
      const fileType = file.name.split('.').pop().toLowerCase();
      if (fileType !== 'bed') {
        this.$message.error('Only .bed format files can be uploaded');
        return false;
      }
      this.bedFileName1 = file.name;
      this.bedData1 = file;
      return false;
    },
    beforeUpload2(file) {
      const fileType = file.name.split('.').pop().toLowerCase();
      if (fileType !== 'bed') {
        this.$message.error('Only .bed format files can be uploaded');
        return false;
      }
      this.bedFileName2 = file.name;
      this.bedData2 = file;
      return false;
    },
    handleUploadSuccess(response) {
      console.log(response);
    },
    async submitForm() {
        this.loading = true; // 开始异步操作前显示 loading
        const formData = new FormData();
        formData.append('bed_file_1', this.bedData1);
        formData.append('bed_file_2', this.bedData2);

        this.$axios.post('http://183.175.59.4/devenhancer/overlap/', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(async response => {
          // 立刻跳转
          this.$router.push({ name: 'Overlaplist', params: { res: response.data } });
        })
        .catch(error => {
          // 处理错误
          console.error(error);
        })
        .finally(() => {
          this.loading = false; // 异步操作结束后隐藏 loading
        });
    },
  },
};
</script>

<style scoped>
.box{
  margin-top: 60px;
}
.card-header {
  background-color: #2C3E50;
}
.box /deep/ .el-card__header {
  background-color: #2C3E50;/* 使用深度选择器 */
}
.col2{
  padding: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/analysis/Overlap.vue